import graphqlClient from "@/GQLClient";
import {
  type ResourceInput,
  SaveResourceDocument,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const save = async (resource: ResourceInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveResourceDocument,
    variables: {
      resource,
    },
  });

  if (response.data?.resource?.save?.success) {
    return response.data.resource.save.id;
  }

  throw new SentryGraphQLError();
};

export default {
  save,
};
